import React from "react";
import Creditor from "../../../../models/creditor.js";
import Tip from "../../utility/tip";
import AutoComplete from "../../utility/auto-complete";
import QuestionBox from "../../utility/question-box";
import MessageBox from "../../utility/message-box";
import { creditorConstant } from "../../../constants/constants";
import creditorStore from "../../../store/creditor-store";
import * as creditorAction from "../../../actions/creditor-action";
import rq from "../../utility/rq.js";
import authStore from "../../../store/auth-store";

export default class extends React.Component {
    constructor() {
        super();
        this.state = {
            propError: {},
            creditorData: false,


        };
        this.creditor = new Creditor({});
        this.questionBox = null;
        this.messageBox = null;
        this.onUpdate = this.onUpdate.bind(this);
        this.onUpDateFailed = this.onUpDateFailed.bind(this);
        this.selectCreditorData = null;
        this.user = authStore.getToken().user;

    }
    validet(propToCheck, model, value) {
        this[model][propToCheck] = value;
        if (this[model].getErrors()[propToCheck]) {
            this.state.propError[propToCheck] = true;
        } else {
            delete this.state.propError[propToCheck];
        }
        this.setState(this.state);
    }
    handleKeyUp(propToCheck, model, e) {
        this.validet(propToCheck, model, e.target.value);
    }
    askQuestion(msg, yesCallBack, noCallBack) {
        this.questionBox = (<QuestionBox questionMsg={msg} yesCallBack={yesCallBack} noCallBack={noCallBack}></QuestionBox>);
        this.setState(this.state);
    }

    createCreditor() {
        if (!this.creditor.hasError()) {
            this.askQuestion(`Do you want to update data of ${this.creditor.firmName} ?`, () => {
                creditorAction.upDateCreditor({ creditor: this.creditor, comment: this.refs.comment.value, oldCreditor: this.oldCreditorData });
                this.questionBox = null;
                this.forceUpdate();
            }, () => {
                this.questionBox = null;
                this.forceUpdate();
            });
        } else {
            this.state.propError = Object.assign({}, this.creditor.getErrors());
            this.setState(this.state);
        }
    }
    onUpdate(msg) {
        this.messageBox = MessageBox.showMessage(msg, true, this);
        this.refs.firmName.value = "";
        this.refs.proprietorName.value = "";
        this.refs.contactNo.value = "";
        this.refs.panNumber.value = "";
        this.refs.address.value = "";
        this.refs.maxLimit.value = "";
        this.refs.email.value = "";
        this.searchBox.value = "";
        this.state.creditorData = false;
        this.creditor = new Creditor({});
        this.refs.firmName.focus();
        this.forceUpdate();
    }
    onUpDateFailed(msg) {
        this.messageBox = MessageBox.showMessage(msg, false, this);
        this.forceUpdate();
    }

    componentWillMount() {
        creditorStore.on(creditorConstant.UPDATE_CREDITOR, this.onUpdate);
        creditorStore.on(creditorConstant.UPDATE_CREDITOR_CREATION_FAILED, this.onUpDateFailed);
    }
    componentWillUnmount() {
        creditorStore.removeListener(creditorConstant.UPDATE_CREDITOR, this.onUpdate);
        creditorStore.removeListener(creditorConstant.UPDATE_CREDITOR_CREATION_FAILED, this.onUpDateFailed);
    }

    onCreditorSelect(creditor) {
        if (creditor) {
            rq.getJsonData("/api/v1/creditor/" + creditor.creditorId).then((data) => {
                this.creditor = new Creditor(data[0]);
                this.oldCreditorData = new Creditor(data[0]);

                this.state.creditorData = true;
                this.setState(this.state);
            }).catch((data) => {
                console.log("filed to get data");
            });

        } else {
            this.state.creditorData = false;
            this.creditor = new Creditor({});
            this.setState(this.state);
        }
        this.setState(this.state);
    }
    handleAddNewCreditor(e) {
        if (e.target.checked) {
            this.validet("hasSmallCreditor", "creditor", 1);
        } else {
            this.validet("hasSmallCreditor", "creditor", 0);
        }
    }
    render() {
        return (
            <div className="midholder" ref="holder">
                {this.questionBox}
                {this.messageBox}
                <p className="formMsg">Creditor Edit </p>
                <table className="formTable">
                    <tbody>
                        <tr>
                            <td>
                                <p className="label">Select a Firm Name</p>
                                <AutoComplete
                                    placeholder="Enter a Firm Name"
                                    dataSrc="/api/v1/creditorauto"
                                    dataTobind="shortName"
                                    keyToBind="creditorId"
                                    tabIndex="1"
                                    onSelect={this.onCreditorSelect.bind(this)}
                                    rex={(searchBox) => {
                                        this.searchBox = searchBox;
                                        //this.searchBox.onfocus = this.onSelectEmployeeFocus.bind(this);
                                    }}
                                />
                            </td>
                            <td>
                            </td>
                        </tr>
                    </tbody>
                </table>
                {this.state.creditorData ? <table className="formTable">
                    <tbody>
                        <tr>
                            <td>

                                <Tip
                                    showOn={this.state.propError.firmName}
                                    msg={this.creditor.getErrors().firmName}
                                />
                                <p className="label">Firm Name</p>
                                <input
                                    tabIndex="2"
                                    type="text"
                                    className="formControl inputBox"
                                    placeholder="Firm Name"
                                    onBlur={this.handleKeyUp.bind(this, "firmName", "creditor")}
                                    onKeyUp={this.handleKeyUp.bind(this, "firmName", "creditor")}
                                    ref="firmName"
                                    defaultValue={this.creditor.firmName}
                                />

                            </td>
                            <td>
                                <Tip
                                    showOn={this.state.propError.proprietorName}
                                    pointerStyle={{}}
                                    msg={this.creditor.getErrors().proprietorName}
                                />
                                <p className="label">Proprietor  Name</p>
                                <input
                                    tabIndex="3"
                                    type="text"
                                    className="formControl inputBox"
                                    placeholder="Proprietor Name"
                                    onBlur={this.handleKeyUp.bind(this, "proprietorName", "creditor")}
                                    onKeyUp={this.handleKeyUp.bind(this, "proprietorName", "creditor")}
                                    ref="proprietorName"
                                    defaultValue={this.creditor.proprietorName}

                                />

                            </td>
                        </tr>
                        <tr>

                            <td>

                                <Tip
                                    showOn={this.state.propError.shortName}
                                    pointerStyle={{}}
                                    msg={this.creditor.getErrors().shortName}
                                />
                                <p className="label">Short Name</p>
                                <input
                                    tabIndex="4"
                                    type="text"
                                    className="formControl inputBox"
                                    placeholder="Short Name"
                                    onBlur={this.handleKeyUp.bind(this, "shortName", "creditor")}
                                    onKeyUp={this.handleKeyUp.bind(this, "shortName", "creditor")}
                                    ref="shortName"
                                    defaultValue={this.creditor.shortName}
                                />
                            </td>
                            <td>
                                <Tip
                                    showOn={this.state.propError.email}
                                    pointerStyle={{}}
                                    msg={this.creditor.getErrors().email}
                                />
                                <p className="label">Email</p>
                                <input
                                    tabIndex="5"
                                    type="text"
                                    className="formControl inputBox"
                                    placeholder="Email"
                                    onBlur={this.handleKeyUp.bind(this, "email", "creditor")}
                                    onKeyUp={this.handleKeyUp.bind(this, "email", "creditor")}
                                    ref="email"
                                    defaultValue={this.creditor.email}
                                />


                            </td>
                        </tr>
                        <tr>
                            <td>
                                <Tip
                                    showOn={this.state.propError.contactNo}
                                    pointerStyle={{}}
                                    msg={this.creditor.getErrors().contactNo}
                                />
                                <p className="label">Contact Number </p>
                                <input
                                    tabIndex="6"
                                    type="number"
                                    className="formControl inputBox"
                                    placeholder="Contact Number"
                                    onBlur={this.handleKeyUp.bind(this, "contactNo", "creditor")}
                                    onKeyUp={this.handleKeyUp.bind(this, "contactNo", "creditor")}
                                    ref="contactNo"
                                    defaultValue={this.creditor.contactNo}
                                />


                            </td>
                            <td>
                                <Tip
                                    showOn={this.state.propError.panNumber}
                                    pointerStyle={{}}
                                    msg={this.creditor.getErrors().panNumber}
                                />
                                <p className="label">PanCard Number</p>
                                <input
                                    tabIndex="7"
                                    type="text"
                                    className="formControl inputBox"
                                    placeholder="PanCard Number"
                                    onBlur={this.handleKeyUp.bind(this, "panNumber", "creditor")}
                                    onKeyUp={this.handleKeyUp.bind(this, "panNumber", "creditor")}
                                    ref="panNumber"
                                    defaultValue={this.creditor.panNumber}
                                />



                            </td>
                        </tr>
                        <tr>
                            <td>
                                <Tip
                                    showOn={this.state.propError.maxLimit}
                                    pointerStyle={{}}
                                    msg={this.creditor.getErrors().maxLimit}
                                />
                                <p className="label">Maximum Limit Amount </p>
                                <input
                                    tabIndex="8"
                                    type="text"
                                    className="formControl inputBox"
                                    placeholder="Maximum Limit Amount "
                                    onBlur={this.handleKeyUp.bind(this, "maxLimit", "creditor")}
                                    onKeyUp={this.handleKeyUp.bind(this, "maxLimit", "creditor")}
                                    ref="maxLimit"
                                    defaultValue={this.creditor.maxLimit}
                                />
                            </td>
                            <td>
                                <p className="label">Comment (reason of edit)</p>
                                <input
                                    tabIndex="9"
                                    type="text"
                                    className="formControl inputBox"
                                    ref="comment"
                                />

                            </td>
                        </tr>
                        <tr>
                            <div style={{ display: "flex" }}>
                                <td style={{ lineHeight: "3" }}>

                                    <Tip
                                        showOn={this.state.propError.address}
                                        msg={this.creditor.getErrors().address}
                                    />

                                    <p className="label">Address</p>
                                    <textarea
                                        rows="4"
                                        cols="38"
                                        tabIndex="10"
                                        type="text"
                                        className="formControl "
                                        placeholder="Address"
                                        onBlur={this.handleKeyUp.bind(this, "address", "creditor")}
                                        onKeyUp={this.handleKeyUp.bind(this, "address", "creditor")}
                                        ref="address"
                                        defaultValue={this.creditor.address}
                                    />
                                </td>
                                {this.user.isAdmin ? <td >
                                    <p className="label" style={{ marginTop: " 14px", marginBottom: "19" }} >Added a New Creditor</p>
                                    <label style={{ cursor: "pointer", }}>
                                        <input type="checkbox" defaultChecked={this.creditor.hasSmallCreditor === 1 ? "on" : false} onChange={this.handleAddNewCreditor.bind(this)} /> has Small Creditor
    </label>
                                </td> : false}
                            </div>
                        </tr>

                    </tbody>

                </table> : null}
                {this.state.creditorData ? <button tabIndex="11" className="btn btnOk btnRight" onClick={this.createCreditor.bind(this)}>Edit Creditor</button> : null}
                <div className="clear"></div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/jsx/components/fragments/edit/creditor-edit.jsx